import { useSecurityContext } from '@/contexts/SecurityContext'
import { GraviButton } from '@gravitate-js/excalibrr'
import { IconSparkles } from '@tabler/icons-react'
import { Tooltip } from 'antd'
import { useState } from 'react'
import { GraviChatDrawer } from './index'

/**
 * Sparkle toggle that opens the GraviChat drawer. Rendered ONLY for internal
 * Gravitate users (`hasGravitateAccess()`); everyone else gets `null` — the
 * frontend gate that mirrors the backend `Depends(gravitate_access)` guard on
 * the `/gravitutor/*` proxy (see design doc §Workstream D / §Security).
 */
export function GraviChatButton() {
  const { hasGravitateAccess } = useSecurityContext()
  const [open, setOpen] = useState(false)

  // Gate before any other hook-dependent rendering: non-Gravitate users never
  // see the button (or mount the drawer / its data hooks).
  if (!hasGravitateAccess()) {
    return null
  }

  return (
    <>
      <Tooltip title='Ask Gravi'>
        <GraviButton
          icon={<IconSparkles size={16} />}
          shape='circle'
          onClick={() => setOpen(true)}
          aria-label='Open GraviChat'
        />
      </Tooltip>
      <GraviChatDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
